import './proposal-service-line-amounts.scss'

import {
  Box,
} from '@mui/material'

import FullSupplyCostReceiptAmounts from './full-supply-cost-receipt-amounts'

const ProposalServiceLineAmounts = ({
  comparison,
  currencyCode,
  layout = 'inline',
}: ApplicationProposalServiceLineAmountsProps) => {
  let className = 'application-proposal-service-line-amounts'
  if (layout === 'stacked') {
    className = `${className} application-proposal-service-line-amounts_stacked`
  }

  return (
    <Box className={className}>
      <FullSupplyCostReceiptAmounts
        comparison={comparison}
        currencyCode={currencyCode}
      />
    </Box>
  )
}

export default ProposalServiceLineAmounts
